import type {
  AdminListVideoKyCsParams,
  AdminFinalizeVideoKYCInput,
  AdminListAgentKyCsParams,
  AdminFinalizeAgentKYCInput,
} from '../api'
import adminKycService from './admin-kyc.service'
import { EAdminKycQueryKey } from './admin-kyc.types'

export const adminListVideoKyCsOptions = (params: AdminListVideoKyCsParams) => {
  return {
    queryKey: [EAdminKycQueryKey.ADMIN_KYC_LIST, params],
    queryFn: () => adminKycService.adminListVideoKyCs(params),
  }
}

export const adminFinalizeVideoKycOptions = (
  params: AdminFinalizeVideoKYCInput,
) => {
  return {
    mutationKey: [EAdminKycQueryKey.ADMIN_KYC_FINALIZE, params],
    mutationFn: (data: AdminFinalizeVideoKYCInput) =>
      adminKycService.adminFinalizeVideoKyc(data),
  }
}

export const adminListAgentKyCsOptions = (params: AdminListAgentKyCsParams) => {
  return {
    queryKey: [EAdminKycQueryKey.ADMIN_AGENT_KYC_LIST, params],
    queryFn: () => adminKycService.adminListAgentKyCs(params),
  }
}

export const adminFinalizeAgentKycOptions = (
  params: AdminFinalizeAgentKYCInput,
) => {
  return {
    mutationKey: [EAdminKycQueryKey.ADMIN_AGENT_KYC_FINALIZE, params],
    mutationFn: (data: AdminFinalizeAgentKYCInput) =>
      adminKycService.adminFinalizeAgentKyc(data),
  }
}
